/*
 * View for inspecting and changing categories
 */

define(["marionette", "./template/categoriesTemplate.html"], function (
  Marionette,
  CategoriesTemplate,
) {
  var CategoriesView = {};

  CategoriesView.categoriesView = Marionette.Layout.extend({
    template: CategoriesTemplate,
    triggers: {
      "click #addCategory": "add:category",
    },
    regions: {
      categoryList: "#categoryList",
      category: "#category",
    },
    events: {
      "change #languages": "onChangeLanguages",
    },
    onChangeLanguages: function () {
      var optionSelected = this.$el.find("#languages option:selected").val();
      var languageId = parseInt(optionSelected, 10);
      this.trigger("change:selectedLanguageId", languageId);
    },
  });

  return CategoriesView;
});
